module.exports = __webpack_public_path__ + "44f016fccb48649020c93e270de41f6c.jpg";